import React from "react";
import { createPortal } from "react-dom";

export interface FilesPortalProps {
  portalContainer: HTMLElement;
  children: React.ReactNode;
}

const FilesPortal: React.FC<FilesPortalProps> = ({
  children,
  portalContainer,
}) => {
  return createPortal(children, portalContainer);
};

export default FilesPortal;
